import { FC, useEffect, useState } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchInput: FC<{
  setSearchValue: (searchValue: string) => void;
  icon?: boolean;
  searchTitle: string;
}> = ({ setSearchValue, icon = true, searchTitle }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => setSearchValue(value), 500);
    return () => clearTimeout(timer);
  }, [value]);

  return (
    <TextField
      variant="outlined"
      placeholder={searchTitle}
      value={value}
      onChange={e => setValue(e.target.value)}
      fullWidth
      size="small"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          )
        }
      }}
    />
  );
};

export default SearchInput;
